var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 38V10H30V14H34V38H14Z",
    fill: "#F8312F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10L30 14H34L34 38H14V10H30Z",
    fill: "#FFDE00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 38V10H30V14H34V38H14Z",
    fill: "#00A6ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 38V10H30V14H34V38H14Z",
    fill: "#00A6ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14H30V34H14V14Z",
    fill: "#FFFFFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20V22H28V20H18ZM18 24V26H24V24H18ZM18 28V30H26V28H18Z",
    fill: "#00A6ED"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.1d4b3d44.svg";
export { ForwardRef as ReactComponent };